module.exports = __webpack_public_path__ + "img/comp-kingst.0238b8bc.svg";